import { z } from 'zod'

const rentUnitTypes = [
  'COTTAGE',
  'APARTMENT',
  'ROOM_WITH_BATHROOM',
  'ROOM_WITHOUT_BATHROOM',
  'ROOM_SHARED',
] as const

const extraTypes = [
  'PEOPLE_DAY',
  'UNITY_DAY',
  'UNITY',
  'SINGLE_PAYMENT',
] as const

export const schema = z.object({
  rentUnits: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string().nullable(),
      type: z.enum(rentUnitTypes),
      capacity: z.number().int(),
      singleBeds: z.number().int(),
      marriageBeds: z.number().int(),
      additionalBeds: z.number().int(),
      sofaBeds: z.number().int(),
      bathrooms: z.number().int(),
      media: z.array(
        z.object({
          url: z.string(),
          type: z.union([z.literal('PHOTO'), z.literal('VIDEO')]),
          alt: z.string(),
          width: z.number().int().nullable(),
          height: z.number().int().nullable(),
        }),
      ),
      features: z.object({
        exteriors: z.array(
          z.object({
            id: z.number().int(),
            name: z.string(),
            slug: z.string(),
          }),
        ),
        interiors: z.array(
          z.object({
            id: z.number().int(),
            name: z.string(),
            slug: z.string(),
          }),
        ),
        services: z.array(
          z.object({
            id: z.number().int(),
            name: z.string(),
            slug: z.string(),
          }),
        ),
        accessibilities: z
          .array(
            z.object({
              id: z.number().int(),
              name: z.string(),
              slug: z.string(),
            }),
          )
          .optional(),
      }),
      extras: z.array(
        z.object({
          id: z.number().int(),
          name: z.string(),
          price: z.object({
            amount: z.number().int(),
            currency: z.string(),
          }),
          type: z.enum(extraTypes),
        }),
      ),
      relatedRentUnitUIds: z.array(z.string()),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
